import {UserRole} from '../models/user-role.enum';

export const AUTHORIZED_FOR_USER_ROLES: string = 'authorizedForUserRoles';
export const ALL_ROLES_EXCEPT_VIEWER: Array<UserRole> = [UserRole.Admin, UserRole.ClinicManager, UserRole.MedicalTeam, UserRole.Concierge, UserRole.Chief, UserRole.Counselor, UserRole.Doctor];
